export default "__VITE_ASSET__vlPKGLmE__"